import { applicationStatusesApi } from 'store/api';
import { apiSlice } from './apiSlice';
import { createSafeQueryFn } from './utils/queries';
import { IApplicationStatus, IFindApplicationStatusParams } from 'api/digifi/ApplicationStatusesApi';

export const applicationStatusesSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    findApplicationStatuses: builder.query<
      IApplicationStatus[],
      IFindApplicationStatusParams
    >({
      queryFn: createSafeQueryFn(async (params) => {
        return applicationStatusesApi.find(params);
      }),
    }),
  }),
});

export const { useFindApplicationStatusesQuery, useLazyFindApplicationStatusesQuery } = applicationStatusesSlice;
